
import Tagging from "./Tagging";
import TagModal from "./TagModal";

export {
    Tagging,
    TagModal
};
